
/**
 * @roxi/routify 2.18.19
 * File generated Tue Sep 08 2026 01:47:10 GMT+0000 (Coordinated Universal Time)
 */

export const __version = "2.18.19"
export const __timestamp = "2026-09-08T01:47:10.426Z"

//buildRoutes
import { buildClientTree } from "@roxi/routify/runtime/buildRoutes.js"

//imports
import _agenda from '../src/pages/agenda.svelte'
import _agendaSettings from '../src/pages/agenda-settings.svelte'
import _changePassword from '../src/pages/change-password.svelte'
import _cprSearch from '../src/pages/cpr-search.svelte'
import _dashboard from '../src/pages/dashboard.svelte'
import _dbCore from '../src/pages/db-core.svelte'
import _faq from '../src/pages/faq.svelte'
import _forgotPassword from '../src/pages/forgot-password.svelte'
import _history from '../src/pages/history.svelte'
import _index from '../src/pages/index.svelte'
import _integrations from '../src/pages/integrations.svelte'
import _login from '../src/pages/login.svelte'
import _passwordReset from '../src/pages/password-reset.svelte'
import _passwordlessLogin from '../src/pages/passwordless-login.svelte'
import _pwc100Search from '../src/pages/pwc100-search.svelte'
import _test from '../src/pages/test.svelte'
import _updateSubscription from '../src/pages/update-subscription.svelte'
import _userInfoMenu from '../src/pages/user-info-menu.svelte'
import _wageReport from '../src/pages/wage-report.svelte'
import _wageReportArchived from '../src/pages/wage-report-archived.svelte'
import _wageReportTest from '../src/pages/wage-report-test.svelte'
import _webauthnOptions from '../src/pages/webauthn-options.svelte'

//options
export const options = {}

//tree
export const _tree = {
  "root": true,
  "children": [
    {
      "isPage": true,
      "path": "/agenda",
      "id": "_agenda",
      "component": () => _agenda
    },
    {
      "isPage": true,
      "path": "/agenda-settings",
      "id": "_agendaSettings",
      "component": () => _agendaSettings
    },
    {
      "isPage": true,
      "path": "/change-password",
      "id": "_changePassword",
      "component": () => _changePassword
    },
    {
      "isPage": true,
      "path": "/cpr-search",
      "id": "_cprSearch",
      "component": () => _cprSearch
    },
    {
      "isPage": true,
      "path": "/dashboard",
      "id": "_dashboard",
      "component": () => _dashboard
    },
    {
      "isPage": true,
      "path": "/db-core",
      "id": "_dbCore",
      "component": () => _dbCore
    },
    {
      "isPage": true,
      "path": "/faq",
      "id": "_faq",
      "component": () => _faq
    },
    {
      "isPage": true,
      "path": "/forgot-password",
      "id": "_forgotPassword",
      "component": () => _forgotPassword
    },
    {
      "isPage": true,
      "path": "/history",
      "id": "_history",
      "component": () => _history
    },
    {
      "isIndex": true,
      "isPage": true,
      "path": "/index",
      "id": "_index",
      "component": () => _index
    },
    {
      "isPage": true,
      "path": "/integrations",
      "id": "_integrations",
      "component": () => _integrations
    },
    {
      "isPage": true,
      "path": "/login",
      "id": "_login",
      "component": () => _login
    },
    {
      "isPage": true,
      "path": "/password-reset",
      "id": "_passwordReset",
      "component": () => _passwordReset
    },
    {
      "isPage": true,
      "path": "/passwordless-login",
      "id": "_passwordlessLogin",
      "component": () => _passwordlessLogin
    },
    {
      "isPage": true,
      "path": "/pwc100-search",
      "id": "_pwc100Search",
      "component": () => _pwc100Search
    },
    {
      "isPage": true,
      "path": "/test",
      "id": "_test",
      "component": () => _test
    },
    {
      "isPage": true,
      "path": "/update-subscription",
      "id": "_updateSubscription",
      "component": () => _updateSubscription
    },
    {
      "isPage": true,
      "path": "/user-info-menu",
      "id": "_userInfoMenu",
      "component": () => _userInfoMenu
    },
    {
      "isPage": true,
      "path": "/wage-report",
      "id": "_wageReport",
      "component": () => _wageReport
    },
    {
      "isPage": true,
      "path": "/wage-report-archived",
      "id": "_wageReportArchived",
      "component": () => _wageReportArchived
    },
    {
      "isPage": true,
      "path": "/wage-report-test",
      "id": "_wageReportTest",
      "component": () => _wageReportTest
    },
    {
      "isPage": true,
      "path": "/webauthn-options",
      "id": "_webauthnOptions",
      "component": () => _webauthnOptions
    }
  ],
  "path": "/"
}


export const {tree, routes} = buildClientTree(_tree)

